import { render, staticRenderFns } from "./BCXActionBoxMessageBox.vue?vue&type=template&id=fb45c198&scoped=true"
import script from "./BCXActionBoxMessageBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXActionBoxMessageBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXActionBoxMessageBox.vue?vue&type=style&index=0&id=fb45c198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb45c198",
  null
  
)

export default component.exports